export { default } from "./LabeledText";

import { LabeledTextProps as TLabeledTextProps } from "./LabeledText";
export type LabeledTextProps = TLabeledTextProps;
